<template>
  <div id="content">
    <link rel="stylesheet" href="/themes/ito/css/daily-challenge.css?v=5">

    <div class="container">
      <div id="achievement" class="card card-daily-challenge" style="height: calc(100vh - 190px);">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('menu_item_achievements') }}</span>
          </h5>

          <div class="card-content">
            <div class="nano" style="height: calc(100vh - 275px)">
              <div class="nano-content">
                <div id="achievement-content">
                  <div class="description">
                    {{ $t('complete_all_the_achievements_to_get_rewards') }}
                  </div>

                  <div class="achievement-list">
                    <template v-for="(achievement, index) in achievements">
                      <achievement-item :achievement="achievement" @updateMission="updateMission" />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getAchievements } from "../../models/achievement";
import AchievementItem from "./AchievementItem";

export default {
  name: "Achievement",
  components: { AchievementItem },
  title: 'Missions',

  data() {
    return {
      achievements: [],
    };
  },

  computed: {
    user_info() {
      return this.$store.state.user_info
    }
  },

  created() {
    this.$store.commit('setMenuActive', 'achievement');

    this.fetch();
  },

  methods: {
    fetch() {
      const that = this;

      axios.all([
        getAchievements(),
      ]).then(axios.spread((response) => {
        that.isLoading = false;

        if (response.data.code != 0) {
          return;
        }

        that.achievements = response.data.results.achieve || [];

        this.$nextTick(function () {
          initNanoScroller();
        })


        that.user_info.count_achieve_unread = response.data.results.count_achieve_unread || 0;
      }));
    },

    updateMission(data) {
      this.fetch();
    },

  }
}
</script>

<style scoped></style>
